import React from 'react';
import {Link} from 'react-router-dom';
import data from '../../data/contracts.json';

const Contracts = (props)=>{
	let categories = data.contracts;
	let icon = (num)=>{
		let faicon = null;
		if(num===0){
			faicon = "fa-home";
		}
		if(num===1){
			faicon = "fa-users";
		}
		if(num===2){
			faicon = "fa-briefcase";
		}
		return faicon;
	}
	return (
		<div className="page page-inner not-found pb-5">
			<div className="container-fluid">
				<div className="container p-0">
					<h1 className="page-title">Legal Documents, Forms, and Contracts</h1>
					<div className="page-content">
						<div className="card-deck card-deck-categories">
							{
								categories.map((obj, i)=>{
									return(
										<div className="card" key={i}>
											<div className="card-body">

												<div className="fa-icon text-center">
													<i className={"fa "+icon(i)}></i>
												</div>

												{/* Display categories */}
												<div className="text-center card-title">
													{Object.keys(obj.category)}
												</div>

												{/* Display contract names per category */}
												<ul className="category-contract-list text-center">	
													{
														obj.category[Object.keys(obj.category)].map((obj2, i2)=>{
															return(
																<li key={i2}>
																	<Link to={obj2.url} data-toggle="tooltip" data-placement="right" title={obj2.description}>
																		{obj2.name}
																	</Link>
																</li>
															)										
														})
													}
												</ul>
											</div>	
										</div>
									)
								})
							}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Contracts;


// WEBPACK FOOTER //
// ./src/pages/contracts/Contracts.js